export default function({ state, commit, dispatch, rootGetters }, query) {

    if (typeof query.id !== 'string')
        return

    let providerId = query.providerId ? query.providerId : state.id
    // Get provider id for patient
    if(state.providerPatients.length === 1)
        providerId = state.providerPatients[0].id
    if(!providerId)
        providerId = state.providerPatients
            .flatMap((provider) => provider.patient.map((patient) => ({id: patient.id, providerId: [provider.id]})))
            .find(({ id }) => id === query.id)
            .providerId
    return dispatch('get', {
        url: '/ctc/' + providerId + '/patient/' + query.id + '/?questionnaire=true&score=true'
    }, {
        root: true
    })
    .then((response) => {
        commit('addPatientAnalytics', {
            id: query.id, 
            analytics: response.questionnaire.reduce((acc, analyticObj) => {
                acc[analyticObj.id] = analyticObj
                return acc
            }, {})
        })
    })

}